import { get } from 'lodash'

import { DateFields, Services, isEmpty, joinURLPath } from '@sigma-frontend-libs/commons'
import { Macro } from '@sigma-legacy-libs/cache'

import { globalErrorHandler, macroCacheOptions, projectName, request } from '@/utils'

import render from './render'

const Cache = new Macro(macroCacheOptions)

const cachedGet = Cache.wrapWithCache(async (key, service, id) => {
  return await request.get(joinURLPath(service, id))
})

export default {
  name: 'FormatTable',

  props: {
    value: {
      type: Object,
      default: () => {
        return {}
      }
    },

    service: {
      type: String,
      default: Services.sendings
    }
  },

  data() {
    return {
      loading: false,
      provider: undefined
    }
  },

  computed: {
    paths() {
      const result = [
        'id',
        'chainId',
        'meta.billings.ids',
        'state.detailed.ids',
        'groupId',
        'status',
        'state.status',
        'moderation',
        'pattern',
        'type',
        'channel',
        'source',
        'payload.sender',
        'payload.recipient',
        'text',
        'payload.text',
        'payload.tts',
        'payload.image',
        'payload.file',
        'payload.audio',
        'payload.video',
        'payload.button.url',
        'payload.button.text',
        'payload.buttons',
        'meta.stats.segments',
        'meta.stats.characters',
        'meta.billing.amount',
        'dursec',
        'billsec',
        'amount',
        'data.price',
        'data.multiplier',
        'data.priceCalculation',
        '$options',
        'meta._recipientData',
        'meta.patternId',
        'isRead',
        'title',
        'notification'
      ]

      if (this.checkPermissions(`advanced.${Services.users}.get`)) {
        switch (this.service) {
          case Services.sendings: {
            result.push('Owner')
            break
          }
          case Services.billings: {
            result.push('Owner.id')
            break
          }
          case Services.notifications: {
            result.push('targetUser')
            break
          }
        }
      }

      if (this.checkPermissions(`advanced.${Services.tariffs}.get`)) {
        result.push('TariffId')
      }

      if (this.checkPermissions(`advanced.${Services.providers}.get`)) {
        result.push('meta._routing.provider')
      }

      result.push(DateFields.createdAt, DateFields.updatedAt, DateFields.sentAt, DateFields.deletedAt)

      return result
    },

    items() {
      const result = []
      for (const path of this.paths) {
        const value = get(this.value, path)
        if (this.hasValue(value)) {
          result.push({
            path,
            value
          })
        }
      }

      return result
    }
  },

  async mounted() {
    if (this.checkPermissions(`advanced.${Services.providers}.get`)) {
      const id = this.value?.meta?._routing?.provider
      if (id) {
        this.provider = await this.getData(Services.providers, id)
      }
    }
  },

  methods: {
    hasValue(value) {
      switch (true) {
        case [ null, undefined ].includes(value): return false
        case typeof value === 'number': return true
        case typeof value === 'string': return !isEmpty(value)
        case typeof value === 'object': return Object.keys(value).length > 0
        case Array.isArray(value): return value.length > 0
        default: return false
      }
    },

    async getData(service, id) {
      if (service && id) {
        try {
          this.loading = true
          const key = [ projectName, service, 'get', id ].filter(Boolean).join(':')
          const data = await cachedGet(key, service, id)
          if (data) {
            return data
          }
        } catch (error) {
          globalErrorHandler(error)
        } finally {
          this.loading = false
        }
      }
    }
  },

  render
}
